import React, { useEffect } from "react";
import Typed from "typed.js";
import { Link } from "react-router-dom";
import profile from "../assets/profile2.png";
import { RiFacebookCircleLine } from "react-icons/ri";
import { TiSocialLinkedinCircular } from "react-icons/ti";
import cv from "../assets/Marius_Baldovin_CV.pdf";

const Home = () => {
  //CV download
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = cv;
    link.download = "MariusBaldovinCV.pdf";
    link.click();
  };

  //Animation
  useEffect(() => {
    const message_typed = new Typed("#multiple-text", {
      strings: [
        "Graduated in Computing Science from Solent University.",
        "Motivated to continuously expand knowledge and skills.",
        "Passionate about staying up-to-date on new technologies.",
      ],
      typeSpeed: 100,
      backSpeed: 100,
      backDelay: 1000,
      loop: true,
    });

    // Clean up on component unmount
    return () => {
      message_typed.destroy();
    };
  }, []);
  return (
    <div className="bg-gray-200 min-h-screen flex flex-col sm:flex-row overflow-hidden">
      {/* Left section */}
      <div className="sm:w-1/2 p-4  ">
        <h1 className="text-center mt-10 text-bold mb-4 text-2xl sm:text-left tracking-tight font-extrabold  text-gray-900 dark:text-white">
          Welcome to My Portfolio
        </h1>
        <h2 className="mt-8 sm:mt-32 mb-4 text-2xl text-center sm:text-left  ">
          Hello, I am
        </h2>
        <h2 className=" sm:text-4xl text-2xl sm:text-left text-center font-extrabold mb-2">
          MARIUS BALDOVIN
        </h2>
        <span
          id="multiple-text"
          className=" text-yellow-500 sm:text-left text-center mt-12 sm:text-2xl text-sm "
        >
          message_typed
        </span>

        <div className="flex sm:justify-start justify-center sm:mt-32 mt-14 gap-2 sm:ml-5">
          <Link
            to="https://www.facebook.com/maryus.baldovin/"
            target="_blank"
            rel="noopener noreferrer"
            className=" w-[40px] h-[40px] rounded-full overflow-hidden bg-blue-500 text-white hover:bg-blue-600 transition-colors duration-300"
          >
            <RiFacebookCircleLine size={40} />
          </Link>
          <Link
            to="https://www.linkedin.com/in/marius-baldovin-75b4a3219"
            target="_blank"
            rel="noopener noreferrer"
            className=" w-[40px] h-[40px] rounded-full overflow-hidden bg-blue-500 text-white hover:bg-blue-600 transition-colors duration-300"
          >
            <TiSocialLinkedinCircular size={40} />
          </Link>
        </div>
        <div className="flex sm:justify-start justify-center">
          <button
            type="submit"
            onClick={handleDownload}
            class=" animate-jump-in animate-once mt-5 py-3 px-5 text-sm font-bold text-center text-gray-950 rounded-3xl bg-yellow-500 sm:w-fit hover:bg-yellow-600 focus:ring-4 focus:outline-none focus:ring-primary-300 "
          >
            Download CV
          </button>
        </div>
      </div>

      {/* Right section */}
      <div className="sm:w-1/2 p-4 ">
        <img
          src={profile}
          alt="Profile"
          className=" w-11/12 animate-shake animate-once "
        />
      </div>
    </div>
  );
};

export default Home;
